import apiClient from '../utils/apiClient';

export const randomRewardAPI = {
  // ── Distributions ─────────────────────────────────────────────────────────
  list: async (params = {}) =>
    apiClient.get({ url: '/random-reward/distributions', params }),

  findOne: async (id) =>
    apiClient.get({ url: `/random-reward/distributions/${id}` }),

  create: async (data) =>
    apiClient.post({ url: '/random-reward/distributions', data }),

  update: async (id, data) =>
    apiClient.patch({ url: `/random-reward/distributions/${id}`, data }),

  remove: async (id) =>
    apiClient.delete({ url: `/random-reward/distributions/${id}` }),

  // ── Simulator & AI ────────────────────────────────────────────────────────
  simulate: async (id, body) =>
    apiClient.post({ url: `/random-reward/distributions/${id}/simulate`, data: body }),

  simulateAdHoc: async (body) =>
    apiClient.post({ url: '/random-reward/simulate-adhoc', data: body }),

  aiSuggest: async (body) =>
    apiClient.post({ url: '/random-reward/ai-suggest', data: body }),

  // ── Audit ────────────────────────────────────────────────────────────────
  audit: async (id, params = {}) =>
    apiClient.get({ url: `/random-reward/distributions/${id}/audit`, params }),

  // ── Dashboard ────────────────────────────────────────────────────────────
  dashboard: async (params = {}) =>
    apiClient.get({ url: '/random-reward/dashboard', params }),
};
